import { render, staticRenderFns } from "./OCRadio.vue?vue&type=template&id=2093244c&scoped=true&"
import script from "./OCRadio.vue?vue&type=script&lang=ts&"
export * from "./OCRadio.vue?vue&type=script&lang=ts&"
import style0 from "./OCRadio.vue?vue&type=style&index=0&id=2093244c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2093244c",
  null
  
)

export default component.exports